import * as React from "react";

interface SimpleCheckboxProps {
    isChecked: boolean
    id?: string
    label?: string
    onChange?: (next: boolean) => void
    disabled?: boolean
    readOnly?: boolean
    className?: string
}

export class SimpleCheckbox extends React.Component<SimpleCheckboxProps> {

    handleChange = (ev: any) => {
        if (this.props.onChange) {
            this.props.onChange(ev.target.checked);
        }
    };

    render(){
        return (
            <div id={`${this.props.id}-div`} className={`simple-checkbox ${this.props.disabled ? "disabled" : ""} ${this.props.className ? this.props.className : ""}`}>
                <input
                    type="checkbox"
                    id={this.props.id}
                    name="actionableToggleInput"
                    onChange={ this.handleChange }
                    checked={ this.props.isChecked }
                    disabled={this.props.disabled || false}
                    readOnly={this.props.readOnly || false}
                />
                <label htmlFor={this.props.id}>
                    <span>
                        <i className={`icon ${ this.props.isChecked ? "icon-check-square" : "icon-square-o"}`}/>
                    </span>
                    {this.props.label || null}
                </label>
            </div>
        );
    }
}